import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC,
  FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC,
  HANDLE_EMAIL_LIST_CHANGE,
  HANDLE_SELECT_ALL_EMAILS,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    emailsList: [],
    data: {},
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC.INITIATE:
        return { ...state, data: {}, loader: true, error: null }
      case FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC.SUCCESS: {
        const formattedData = Object.entries(action.payload.data).map(([address, details]) => ({
          address,
          totalEmails: details.total_emails,
          recipients: details.no_of_recipients,
        }))

        return {
          ...state,
          error: null,
          data: {
            results: formattedData,
            isEmpty: formattedData.length === 0,
          },
          loader: false,
        }
      }

      case FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC.CANCEL:
        return { ...state, loader: false }
      case CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC.SUCCESS:
        return { ...state, error: null, loader: false }
      case CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC.CANCEL:
        return { ...state, loader: false }

      case HANDLE_EMAIL_LIST_CHANGE: {
        const newEmail = action.payload.email
        const index = state.emailsList.indexOf(newEmail)
        return {
          ...state,
          emailsList:
            index >= 0
              ? [...state.emailsList.slice(0, index), ...state.emailsList.slice(index + 1)]
              : [...state.emailsList, newEmail],
        }
      }
      case HANDLE_SELECT_ALL_EMAILS: {
        const emails = action.payload.emails
        return {
          ...state,
          emailsList: emails,
        }
      }

      default:
        return state
    }
  }
}
